var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 126,
    viewBox: "0 0 106 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4496 29.6754L7.64941 34.5673L15.0683 43.3636L20.8684 38.4717L13.4496 29.6754Z",
    fill: "#45485C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9785 23.1657C12.2103 21.0696 9.07913 20.8042 6.98232 22.5716L1.7637 26.9729C-0.332328 28.741 -0.597743 31.873 1.16964 33.969C2.9378 36.065 6.06896 36.3304 8.16578 34.5631L13.3836 30.1618C15.4804 28.3936 15.7458 25.2617 13.9785 23.1657Z",
    fill: "#FD7401"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6847 38.4775L89.4849 43.3694L96.9037 34.5731L91.1036 29.6812L83.6847 38.4775Z",
    fill: "#45485C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6168 23.1657C92.385 21.0696 95.5162 20.8042 97.613 22.5716L102.832 26.9729C104.928 28.741 105.193 31.873 103.426 33.969C101.658 36.065 98.5263 36.3304 96.4303 34.5631L91.2109 30.1618C89.1157 28.3936 88.8487 25.2617 90.6168 23.1657Z",
    fill: "#FD7401"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2919 13.8549H47.9788V30.104H59.2919V13.8549Z",
    fill: "#45485C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.635 22.3327C25.008 22.3327 1.80176 45.5397 1.80176 74.1667C1.80176 102.794 25.0088 126 53.635 126C82.2613 126 105.468 102.793 105.468 74.1667C105.468 45.5405 82.262 22.3327 53.635 22.3327ZM53.635 114.276C31.4834 114.276 13.5255 96.3183 13.5255 74.1667C13.5255 52.0152 31.4834 34.0572 53.635 34.0572C75.7874 34.0572 93.7445 52.0144 93.7445 74.1667C93.7445 96.3183 75.7874 114.276 53.635 114.276Z",
    fill: "#1B3E61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6352 114.276C75.7871 114.276 93.7447 96.3186 93.7447 74.1667C93.7447 52.0148 75.7871 34.0571 53.6352 34.0571C31.4833 34.0571 13.5256 52.0148 13.5256 74.1667C13.5256 96.3186 31.4833 114.276 53.6352 114.276Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7957 38.3554H52.4772V46.624H54.7957V38.3554Z",
    fill: "#45485C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7957 101.709H52.4772V109.977H54.7957V101.709Z",
    fill: "#45485C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.885 49.7334L36.7507 42.5728L34.7429 43.732L38.8772 50.8926L40.885 49.7334Z",
    fill: "#45485C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.572 104.609L68.4377 97.4488L66.4306 98.6077L70.5649 105.768L72.572 104.609Z",
    fill: "#45485C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3613 59.3769L23.2014 55.243L22.0421 57.2508L29.2021 61.3848L30.3613 59.3769Z",
    fill: "#45485C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2466 91.0824L78.0852 86.949L76.9266 88.9564L84.088 93.0898L85.2466 91.0824Z",
    fill: "#45485C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0935 73.0067H17.825V75.3252H26.0935V73.0067Z",
    fill: "#45485C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4474 73.0067H81.1788V75.3252H89.4474V73.0067Z",
    fill: "#45485C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3659 88.9362L29.2065 86.9292L22.0474 91.0648L23.2068 93.0717L30.3659 88.9362Z",
    fill: "#45485C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.252 57.2369L84.0925 55.2293L76.9327 59.3644L78.0922 61.372L85.252 57.2369Z",
    fill: "#45485C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.898 98.619L38.8899 97.4599L34.7564 104.621L36.7645 105.78L40.898 98.619Z",
    fill: "#45485C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5483 43.7294L70.5414 42.5701L66.4058 49.7291L68.4128 50.8885L72.5483 43.7294Z",
    fill: "#45485C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.635 79.6172C56.6452 79.6172 59.0855 77.1769 59.0855 74.1667C59.0855 71.1565 56.6452 68.7163 53.635 68.7163C50.6248 68.7163 48.1846 71.1565 48.1846 74.1667C48.1846 77.1769 50.6248 79.6172 53.635 79.6172Z",
    fill: "#FD7401"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1084 7.11404C64.1084 3.52463 61.199 0.615967 57.6111 0.615967H49.7937C46.2051 0.615967 43.2957 3.52541 43.2957 7.11404V8.99775C43.2957 12.5864 46.2059 15.4958 49.7937 15.4958H57.6111C61.1998 15.4958 64.1084 12.5856 64.1084 8.99775V7.11404Z",
    fill: "#FD7401"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4719 69.6383L44.4929 54.9989L48.5281 72.4533L53.6351 74.1668L55.4719 69.6383Z",
    fill: "#FD7401"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6353 76.6383C55.0003 76.6383 56.1069 75.5317 56.1069 74.1667C56.1069 72.8017 55.0003 71.6952 53.6353 71.6952C52.2704 71.6952 51.1638 72.8017 51.1638 74.1667C51.1638 75.5317 52.2704 76.6383 53.6353 76.6383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dec36e1c45d8eaa594d3550cf0bce660.svg";
export { ForwardRef as ReactComponent };